import 'css-chunksrc/client/pages/projectPage/kanbanPage/loader/column/task/allocationsList/styles.scss';export default {
  "allocationsList": "_allocationsList_geqv8_1",
  "allocation": "_allocation_geqv8_1"
};